<template>
	<div :class="[loaction != '/home/visualization'?'home':'home visualization']"> 
		<el-container style="height:100%;">
			<div class="menuStyle" :id="userNameType=='ANINSPECTOR'?'supervisorMenu':''" v-if="userNameType!='VISUALIZATION'">
				<el-row class="elrow">
					<el-col :span="24" v-show="isTree">
						<div class="homeTree" v-if="userNameType=='ANINSPECTOR'">
							<el-tree :data="regionsList" :props="defaultProps" node-key='UniqueId' ref="tree" auto-expand-parent
							 :default-expanded-keys="expandeds" accordion :highlight-current="true" @node-click="handleNodeClick"
							 :render-content="renderContent"></el-tree>
						</div>
						<el-menu v-else unique-opened router :default-active="navselected.path" :default-openeds="openeds" :collapse="menuStatus.isCollapse" class="left-menu" @select="handleSelect">
							<sidebar-item :menu="links" :userNameType="userNameType" />
						</el-menu>
					</el-col>
				</el-row>
			</div>
			<el-container>
				<el-header>
					<div class="homeUserNav">
						<headers :bg="bg.flag"></headers>
					</div>
				</el-header>
				<!--面包屑-->
				<!-- ||$route.path!='/home/visualization' -->
				<div :class="shadowShow?'inlin pdl22 breadcrumbBox':'inlin pdl22'">
					<el-breadcrumb v-if="userNameType=='ANINSPECTOR'" :class="userNameType=='ANINSPECTOR'&&breadLists.breadList.length<=1?'breadcrumb inlin':'breLastAct breadcrumb inlin'"
					 separator-class="el-icon-arrow-right">
						<!-- <el-breadcrumb-item @click.native="handleToHome">全国</el-breadcrumb-item> -->
						<el-breadcrumb-item v-for='(item,index) in breadOption' :key='index' @click.native="cityClick(item,index)" v-if='item.Name'
						 style="cursor: pointer">
							{{item.Name}}
						</el-breadcrumb-item>
					</el-breadcrumb>
					<el-breadcrumb class="breadcrumb inlin" v-if="$route.path!='/home/visualization'" separator="/" separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-if="userNameType=='ANINSPECTOR'"></el-breadcrumb-item>
						<el-breadcrumb-item v-for='(item,index) in breadLists.breadList' :key='index' @click.native="breadcrumbClick(item)" v-if='item.name&&item.name!="监察员"'
						 style="cursor: pointer">
							{{item.name}}
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<el-main ref="bigBox">
					<transition name="fade" mode="out-in">
						<keep-alive :include="cachedViews">
							<router-view class="main_content" v-if="isRouterVlive" ref="currentView" />
						</keep-alive>
					</transition>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<script>
	import SidebarItem from "@/components/tool/SidebarItem";
	import Headers from "../components/Common/header"
	import {myMixin} from "@/assets/mixin.js"
	// import { mapState, mapActions, mapMutations} from 'vuex'
	export default {
		name: 'home',
		mixins:[myMixin],
		data() {
			return {
				// breadList: [],
				isRouterVlive: true,
				expandeds: [],
				defaultProps: {
					children: 'Children',
					label: 'Name'
				},
				userName: JSON.parse(localStorage.getItem('user')),
				userNameType: JSON.parse(JSON.parse(localStorage.getItem('user')).permissions)[0].KeyName,
				loaction: "",
				breadOption: [],
				shadowShow: false,
				links:JSON.parse(localStorage.getItem('links')),
			}
		},
		components: {
			SidebarItem,
			Headers
		},
		watch: {
			$route(to, from) {
				this.loaction = to.path;
				this.menuActive();
				this.getBreadcrumb();
				
			},
			triggers(old) {
				if (this.userNameType == 'ANINSPECTOR') {
					if (old) {
						for (let i = 0; i < this.$refs.tree.store._getAllNodes().length; i++) {
							this.$refs.tree.store._getAllNodes()[i].expanded = false;
						}
						if(this.memoryFlag.flag){
							this.$refs.tree.setCurrentKey(this.treeDefault.checked);
							this.expandeds = [this.treeDefault.checked];
						}else{
							this.expandeds = this.treeDefault.expanded
						}
					}
				}
			},
			userNameType: {
				immediate: true, // immediate选项可以开启首次赋值监听
				handler(newVal, oldVal) {
					let routePath = localStorage.getItem('routePath');
					this.loaction = this.$route.path;
					if (routePath) {
						let goPath = this.$route.path.split('/').join(',').match(/,[^,]*,([^\,]*)/)
						let beforePath = routePath.split('/').join(',').match(/,[^,]*,([^\,]*)/)
						if (beforePath&&(beforePath[1] != goPath[1])) {
							if (this.menuFlag) {
								this.setMenuFlag(false);
								this.$router.push({
									path: this.permissions
								})
							}
						}
					} else {
						localStorage.setItem('routePath', this.$route.path)
					}
				}
			}
		},
		computed: {
			...Vuex.mapState('breadcrumb', ['breadLists','menuStatus', 'navselected', 'cachedViews', 'breadListState','bg','loading','isTree']),
			...Vuex.mapState('login', ['menuFlag','permissions','openeds']),
			...Vuex.mapState('doctor', ['doctor', 'experts']),
			...Vuex.mapState('managerPlanList', ['TaskStatisticByMonthParameter']),
			...Vuex.mapState('supervisor', ['memoryFlag','regionType','regionsList', 'HospitalAVGScoreArr', 'HospitalAVGScoreBtn', 'isShowEcharts',
				'DoctorsAvgScoreArr', 'trigger', 'treeDefault', 'isRightPie', 'formInlines', 'dialogVisible','HospitalAVGScoreName','DoctorsAvgScoreName'
			]),
			triggers() {
				return this.trigger.doctor
			}
		},
		mounted() {
			if(this.links.length<=0){
				this.setLinks(JSON.parse(localStorage.getItem('links')))
			}
			this.switchStatus();
			// this.$nextTick(function() {
			// 	this.loaction = this.$route.path;
			// 	if (this.userNameType == 'ANINSPECTOR') {
			// 		this.GetRegions({}).then(res => {}).catch(err => {});
			// 	}
			// })
			let _this = this;
			window.addEventListener('scroll', () => {
				let scrollTop = document.documentElement.scrollTop ||
					document.body.scrollTop ||
					document.querySelector('.el-main').scrollTop;
				if (scrollTop != 0) {
					_this.shadowShow = true;
				} else {
					_this.shadowShow = false;
				}
			}, true);
			if (localStorage.getItem("path")) {
				this.navselected.path = localStorage.getItem("path");
			}
			this.menuActive();
			if (this.$route.meta.length > 0) {
				this.getBreadcrumb();
			}
			if (this.userNameType == 'ANINSPECTOR') {
				this.initDate();
				this.GetRegions({}).then(res => {
						if (_this.regionsList) {
							_this.breadOption.push({
								'Name': _this.regionsList[0].Name,
								'RegionType':_this.regionsList[0].RegionType,
								'UniqueId': _this.regionsList[0].UniqueId
							})
							let obj = {};
							_this.breadOption = _this.breadOption.reduce(function(a, b) {
								obj[b.UniqueId] ? '' : obj[b.UniqueId] = true && a.push(b);
								return a;
							}, [])
						}
					})
					.catch(err => {});
					this.GetHospitalAVGScore();
					this.GetDoctorsAvgScore();
					this.callFun();
					this.$nextTick(res=>{
						this.initMakeUp()
					})
			}
		},
		updated() {
			if (this.userNameType == 'ANINSPECTOR') {
				this.$refs.tree.setCurrentKey(this.treeDefault.checked);
			}
		},
		methods: {
			...Vuex.mapActions('breadcrumb', ['breadListMutations']),
			...Vuex.mapActions('login', ['changeRouter', 'setMenuFlag']),
			...Vuex.mapActions('supervisor', ['GetRegions', 'GetHospitalAVGScore', 'GetHospitalUnqualifiedReport',
				'GetDoctorsAvgScore', 'GetDoctorUnqualifiedReport', 'ChangePasswordAct','GetSummary','GetCount','HospitalAVGScore'
			]),
			...Vuex.mapMutations('breadcrumb', ['changenavselected','changeisTree']),
			...Vuex.mapMutations('login', ['setLinks']),
			...Vuex.mapMutations('supervisor', ['clearPass', 'setHospitalAVGScoreBtn', 'skinPeelermut', 'zoneBtnChange',
				'sortOrderTypeChange', 'doctorShowTypeChange', 'setSplitScreen','GetRegionAVGScore', 'GetRegionUnqualifiedReport','initDate'
			]),
			...Vuex.mapMutations('doctor', ['drawerShow']),
			...Vuex.mapMutations('managerPlan', ['clearInit']),
			reload() {
			  this.isRouterAlice = false
			  this.$nextTick(function() {
			    this.isRouterAlice = true
			  })
			},
			// 调用的接口
			callFun(){
				this.GetSummary();
				this.GetCount();
			},
			handleCommand(command) {
				//显示修改密码弹窗
				if (command == 'changePassword') {
					this.clearPass();
					this.dialogVisible.open = true;
				}
			},
			//导航被选中
			menuActive() {
				if(typeof this.links == 'string'){
					this.links = JSON.parse(this.links);
				}
				this.links.filter((item) => {
					// 这要写个递归找第二层呢
					if (item.RoutePath == this.$route.path) {
						this.navselected.path = item.RoutePath;
						localStorage.setItem("path", item.RoutePath)
						return item.RoutePath;
					}
				})
				let _this = this;
				function getName(vals) {
					vals.forEach((item, index) => {
						if (item.children&&item.children.length>0) {
							getName(item.children)
						}else{
							if(item.RoutePath == _this.$route.path){
								_this.navselected.path = item.RoutePath;
								localStorage.setItem("path", item.RoutePath)
								return false
							}
						}
					})
				}
				getName(this.links);
			},
			// 面包屑数据处理
			getBreadcrumb() {
				let _this = this;
				// 由于本项目大部分属于‘一级’页面，所以在设置路由时候，一级页面不设置breadNumber = 1，‘二级’页面以上才设置breadNumber
				let Number = this.$route.meta[0].breadNumber;
				let breadNumber = typeof(Number) !== 'undefined' ? Number : 1;
				// 获取当前页面的名字和路由，并组合成新的对象
				let newBread = {
					name: this.$route.meta[0].name,
					path: this.$route.fullPath,
					breadNumber:this.$route.meta[0].breadNumber
				};
				let vuexBreadList = []; // 默认初始化面包屑数据
				if (breadNumber !== 1) {
					// 当前面包屑breadNumber大于1时才会从vuex中获取值
					vuexBreadList = _this.$store.state.breadcrumb.breadListState; // 获取breadList数组
				}
				// if (breadNumber < vuexBreadList.length) {
				// 	// "回退"面包屑----判断条件：当前路由breadNumber小于vuexBreadList的长度
				// 	vuexBreadList.splice(breadNumber - vuexBreadList.length, vuexBreadList.length - breadNumber);
				// }
				if (breadNumber > vuexBreadList.length) {
					// 添加面包屑----判断条件：当前路由breadNumber大于vuexBreadList的长度
					vuexBreadList.push(newBread);
				}
				
				
				let path = this.loaction;
				this.breadListState.forEach((item,index)=>{
					if(item.path == path){
						this.breadListState.splice(index+1, this.breadListState.length-1-index);
					}
				})
				// 处理完数据后，将最终的数据更新到vuex（用于页面刷新）
				_this.$store.commit('breadcrumb/breadListMutations', vuexBreadList);
				//		      _this.breadListMutations(vuexBreadList)
				// 处理完数据后，将最终的数据更新为新的面包屑数组
				_this.breadLists.breadList = vuexBreadList;
			},
			breadcrumbClick(item) {
				this.drawerShow(false);
				this.$router.push({
					path: item.path
				})
			},
			//机构
			defaultGet(type) {
				//区域排名
				if(type) {
					this.defaultDoctorGet();
				} else {
					if(this.HospitalAVGScoreBtn.average) {
						this.GetHospitalAVGScore();
						this.GetDoctorsAvgScore();
					}
					if(this.HospitalAVGScoreBtn.deduct) {
						this.GetHospitalUnqualifiedReport();
						this.GetDoctorUnqualifiedReport();
					}
					this.callFun();
				}
				// if (this.HospitalAVGScoreBtn.average) {
				// 	this.GetHospitalAVGScore();
				// }
				// if (this.HospitalAVGScoreBtn.deduct) {
				// 	this.GetHospitalUnqualifiedReport();
				// }
			},
			defaultDoctorGet() {
				if(this.HospitalAVGScoreBtn.average) {
					this.GetRegionAVGScore();
					this.GetDoctorsAvgScore();
				}
				if(this.HospitalAVGScoreBtn.deduct) {
					this.GetDoctorUnqualifiedReport();
					this.GetRegionUnqualifiedReport();
				}
			},
			//点击面包屑
			cityClick(item, index) {
				for (let i = this.breadOption.length; i > 0; i--) {
					if (this.breadOption[i - 1].UniqueId != item.UniqueId) {
						this.breadOption.pop();
					} else {
						break;
					}
				}
				this.changeisTree(true);
				if(this.memoryFlag.flag){
					this.$refs.tree.setCurrentKey(this.treeDefault.checked);
					this.HospitalAVGScoreArr.regionId = this.treeDefault.checked;
					this.retainModification({
						UniqueId:this.HospitalAVGScoreArr.regionId
					});
				}else{
					if(item.RegionType == 2){
						this.$refs.tree.setCurrentKey(item.UniqueId);
						this.treeDefault.checked = item.UniqueId;
						this.HospitalAVGScoreArr.regionId = this.treeDefault.checked;
						this.GetHospitalAVGScore();
					}
					if(item.RegionType != 5){
						this.retainModification(item);
					}
				}
				
				this.$router.push("/home/supervisor")
			},
			//点击全国
			handleToHome() {
				let item = {
					'Name': this.regionsList[0].Name,
					'RegionType':_this.regionsList[0].RegionType,
					'UniqueId': this.regionsList[0].UniqueId
				}
				this.breadOption = [];
				this.breadOption.push(item);
				this.retainModification(item);
				this.$router.push("/home/supervisor")
			},
			//抽离面包屑list
			findNodeList(node) {
				this.breadOption = [];
				/*临时变量nodeData储存被点击节点的node信息，判断如果此节点有父节点，
				那么将相关信息添加到面包屑的首位，并将父节点赋值给临时节点，继续判断该节点是否有父节点*/
				let nodeData = node;
				while (nodeData.parent != null) {
					this.breadOption.unshift({
						'Name': nodeData.data.Name,
						'RegionType':nodeData.data.RegionType,
						'UniqueId': nodeData.data.UniqueId
					});
					nodeData = nodeData.parent;
				}
			},
			//返回顶部
			backtop() {
				let top = document.documentElement.scrollTop || document.body.scrollTop || document.querySelector('.el-main').scrollTop
				// 实现滚动效果
				const timeTop = setInterval(() => {
					document.body.scrollTop = document.documentElement.scrollTop = document.querySelector('.el-main').scrollTop =
						top -= 10
					if (top <= 0) {
						clearInterval(timeTop)
					}
				}, 10)
			},
			jumpTo(){
				if (this.loaction != "/home/supervisor") {
					this.$router.push("/home/supervisor")
				} else {
					document.documentElement.scrollTop = document.body.scrollTop = document.querySelector('.el-main').scrollTop = 0;
				}
			},
			requestJudgment(data,node,type){
				// let _this = this;
				this.regionType.type = data.RegionType;
				this.regionType.HospitalGuid = '';
				//机构列表				
				if (data.RegionType == 5) {
					this.regionType.HospitalGuid = data.UniqueId;
					this.DoctorsAvgScoreArr.hospitalGuid = data.UniqueId;
					this.HospitalAVGScoreArr.regionId = node.parent.data.UniqueId;
					// this.$refs.currentView.$refs.originzation.getEcharts();
					if(this.HospitalAVGScoreBtn.average) {
						// this.GetHospitalAVGScore();
						this.GetDoctorsAvgScore();
					}
					if(this.HospitalAVGScoreBtn.deduct) {
						// this.GetHospitalUnqualifiedReport();
						this.GetDoctorUnqualifiedReport();
					}
					this.callFun();
					// this.defaultGet(type);
				} else {
					this.DoctorsAvgScoreArr.hospitalGuid = '';
					this.HospitalAVGScoreArr.regionId = data.UniqueId;
					if (data.RegionType == 3) {
						if (data.Children.length > 1) {
							this.isShowEcharts.hospital = true;
						} else {
							this.isShowEcharts.hospital = false;
						}
					} else {
						this.isShowEcharts.hospital = true;
					}
					this.defaultGet(type)
				}
			},
			retainModification(data){
				this.jumpTo();
				this.requestJudgment(data,undefined,'crumbs');
			},
			makeUp(){
				this.HospitalAVGScoreName.makeUp = this.HospitalAVGScoreName.name + this.HospitalAVGScoreName.region + this.HospitalAVGScoreName.condition + this.HospitalAVGScoreName.rank;
				this.DoctorsAvgScoreName.makeUp = this.DoctorsAvgScoreName.name + this.DoctorsAvgScoreName.type +  this.DoctorsAvgScoreName.condition + this.DoctorsAvgScoreName.rank;
			},
			initMakeUp(){
				this.HospitalAVGScoreName.name = '全国';
				this.HospitalAVGScoreName.region = '影像中心';
				this.HospitalAVGScoreName.condition = '平均分';
				this.HospitalAVGScoreName.rank = '排名';
				this.DoctorsAvgScoreName.name = '全国';
				this.DoctorsAvgScoreName.type = '医生';
				this.DoctorsAvgScoreName.condition = '平均分';
				this.DoctorsAvgScoreName.rank = '排名';
				this.makeUp();
			},
			changeName(data, node){
				if(data.RegionType < 5){
					this.HospitalAVGScoreName.name = data.Name;
					this.DoctorsAvgScoreName.name = data.Name;
				}else{
					this.HospitalAVGScoreName.name = node.parent.label;
					this.DoctorsAvgScoreName.name = data.Name;
				}
				this.makeUp();
			},
			handleSelect(key, keyPath){
				this.TaskStatisticByMonthParameter.PageIndex = 1;
				//初始化
				this.clearInit()
			},
			//改变视图数据
			handleNodeClick(data, node) {
				this.histogramClickType = false;
				if(data.RegionType == 1){
					this.memoryFlag.flag = true;
				}else{
					this.memoryFlag.flag = false;
				}
				this.initMakeUp();
				this.makeUp();
				this.changeName(data, node);
				this.DoctorsAvgScoreArr.pageIndex = 1;
				this.jumpTo();
				if (node) {
					this.findNodeList(node);
				}
				//右侧饼图恢复
				this.isRightPie.pie = true;
				//报告条件恢复
				this.setHospitalAVGScoreBtn('average');
				//医生类型恢复
				this.HospitalAVGScoreArr.type = 2;
				//排名类型恢复
				this.trigger.regionsData = false;
				//机构排序恢复
				this.HospitalAVGScoreArr.sortType = 2;
				this.sortOrderTypeChange(2);
				this.treeDefault.checked = data.UniqueId;
				this.doctorShowTypeChange(data.RegionType);
				//判断是否有排名类型
				this.zoneBtnChange();
				this.requestJudgment(data,node);
			},
			/*初始化树，添加文件图标*/
			renderContent(h, {
				node,
				data,
				store
			}) {
				if (node.label == '全国') {
					return ( <
						span class = "el-treeSpanlist" >
						<
						span class = "pdl17" >
						<
						i class = "iconfont iconicon-Navigation-wholecountry fz14" > < /i> <
						span > {
							node.label
						} < /span> <
						/span> <
						/span>);
					}
					else {
						return ( <
							span class = "el-treeSpanlist" >
							<
							span class = "pdl17" >
							<
							span > {
								node.label
							} < /span> <
							/span> <
							/span>);
						}

					},
				}

			}
</script>

<style scoped>

</style>
